import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";
import { SESSION_REMOVE_ITEM } from "Components/constants/enums";
import { useNavigate } from "react-router-dom";

const AuthProtected = (props : any) =>{
  const dispatch : any = useDispatch();
  const { userProfile, loading, token } = useProfile();
  const navigate = useNavigate()
  
  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      SESSION_REMOVE_ITEM()
        navigate("/login")
    }
  }, [token, userProfile, loading, dispatch]);

  if (!userProfile && loading && !token) {
    return (
      <React.Fragment>
        <Navigate to={{ pathname: "/login"}} />
      </React.Fragment>
    );
  }

  return <>{props.children}</>;
};


export default AuthProtected;
